module.exports = __webpack_public_path__ + "img/delivery_service.57921228.svg";